
import MuiCircularProgress from '@mui/material/CircularProgress';
import { CommonPropsAndTypes } from '../../_Types/StandardComponentProps';
import { Theme } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import EDOverlay from '../../Overlay/EDOverlay';
import EDTypography from '../../Typography/EDTypography';

interface IProps {
  value: number;
  color?: CommonPropsAndTypes.AlternateLimitedColorType;
  size?: number;
  thickness?: number;
  classes?: Partial<Record<keyof ReturnType<typeof styles>, string>>;
  className?: string;
}

const styles = (theme: Theme) => ({
  overlay: {
    top: theme.spacing(0),
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  /** MUI Classes */
  /** Styles applied to the root element. */
  root: {},
  colorPrimary: {},
});

export const EDStaticProgress: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const { overlay, ...muiClasses } = withStyles.getClasses(props);
  return (
    <EDOverlay
      overlay={
        <EDTypography color="primary" variant="caption">
          <strong>{`${Math.floor(props.value)}%`}</strong>
        </EDTypography>
      }
      classes={{ overlay: overlay }}
      size={props.size}
    >
      <MuiCircularProgress
        color={props.color}
        size={props.size}
        thickness={props.thickness}
        className={props.className}
        classes={muiClasses}
        variant="determinate"
        value={props.value}
      />
    </EDOverlay>
  );
};

export default withStyles(EDStaticProgress, styles);
